import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import BarChartRegular from './bar-chart-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <BarChartRegular {...validProps} />;
}
SvgComponent.iconName = 'barChartRegular';

export const BarChartRegularIcon = svgIconWrapper(SvgComponent);
